<template>
  <div class="container topPage activityIndex" style="padding-top:0.26667rem !important">
    <!-- <van-nav-bar title="活动" left-text /> -->
    <van-row class="searchWrap ">
      <div class="searchName">所有活动</div>
      <van-search class="searchBox" placeholder="请输入搜索关键词" v-model="keywords.keyWords" @search="onSearch" />
    </van-row>
    <van-dropdown-menu >
      <van-dropdown-item v-model="keywords.unionId" :options="option1" @change='dropChange'/>
      <van-dropdown-item v-model="keywords.activityType" :options="option2" @change='dropChange'/>
      <van-dropdown-item v-model="keywords.dateCondition" :options="option3" @change='dropChange' />
      <van-dropdown-item v-model="keywords.integralCondition" :options="option4" @change='dropChange'/>
      <van-dropdown-item v-model="keywords.consumeMoneyCondition" :options="option5" @change='dropChange'/>
    </van-dropdown-menu>
    <van-empty description="什么都没有~" v-show='isEmpty'/>
    <van-list style="margin-top:-5px" v-model="loading" :finished="finished" :finished-text="finishText" @load="onLoad" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载" :offset="30">
      <div class="pageList">
        <transition-group v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
          <div class="padding15 pageListItem" v-for="(item, index) in dataList" :key="item.id" :data-delay="index * 20" data-y="100%" @click="handleRecDeatails(item.id)">
            <div class="actPicture">
              <van-image fit="cover" :src="item.photoUrl" />
              <div class="signState" v-show='item.isSignUp===2'>
                <span class="dot"></span>已报名
              </div>
            </div>
            <div class="actText">
              <van-row type="flex" justify="space-between" class="colorBlack">
                <van-col span="24" class="van-ellipsis fz16 textBold marginBottom3">{{item.activityName}}</van-col>
              </van-row>
              <van-row type="flex" justify="space-between" class="marginTop3 colorGrey1">
                <!-- <van-col span="24" class="van-ellipsis">开放时间：{{item.businessHours}}</van-col> -->
                <!-- 是否长期(1是 2否) -->
              <van-col span="24" class="van-ellipsis" v-if='item.isLongTerm==2'>活动时间：{{item.activityStartTime}} - {{item.activityEndTime}}</van-col>
              <van-col span="24" class="van-ellipsis" v-if='item.isLongTerm==1'>长期</van-col>
              </van-row>

              <van-row type="flex" justify="space-between" class="marginTop3 colorGrey1 address">
                <van-col span="24" class="van-ellipsis2">地址：{{item.address}}</van-col>
              </van-row>
              <van-row type="flex" justify="space-between" class="marginTop12 points pointsConsume">
              <van-col span="24" class="van-ellipsis">
                <i class="iconfont icon-jifen marginRight5" style="color:#ccc" />
                <span v-if='item.isConsume==1'>消耗虚拟资产:
                  <span class="num">{{minConsumeMoney(item.consumeTypeList)}}</span>元
                </span>
                <span v-if='item.isConsume==2'>免费</span>
              </van-col>
            </van-row>
              <van-row type="flex" justify="space-between" class="marginTop3 points">
                <van-col span="24" class="van-ellipsis">
                  <i class="iconfont icon-jifen marginRight5" style="color:#ccc" />奖励积分:
                  <span class="num">{{item.signUpIntegral}}</span>分
                </van-col>
                <div class="arrowIcon">
                  <van-icon name="arrow" />
                </div>
              </van-row>
            </div>
          </div>
        </transition-group>
      </div>
    </van-list>
    <tab-bar></tab-bar>
    <div class="blankHeight"></div>
  </div>
</template>

<script>
import tabBar from "@/view/component/tabBar";
import { activityList,unionPullList } from "@/api/activity";
export default {
  components: { tabBar },
  data() {
    return {
      option1: [
        { text: "工会", value: '' },
      ],
      option2: [
        { text: "类别", value: ''},
        { text: "固定活动", value: 1 },
        { text: "临时活动", value: 2 },
      ],
      option3: [
        { text: "日期", value:'' },
        { text: "近一周", value: 1 },
        { text: "近一个月", value: 2 },
        { text: "近三个月", value: 3 },
      ],
      option4: [
        { text: "积分", value: '' },
        { text: "1-50", value: 1 },
        { text: "51-100", value: 2 },
         { text: "101分以上", value: 3 },
      ],
      option5: [
        { text: "价格", value: '' },
        { text: "1-100元", value: 1 },
        { text: "101-200元", value: 2 },
        { text: "免费", value: 3 },
      ],
      searchKey: "",
      keywords:{
        keyWords:'',
        unionId:'',
        activityType:'',
        consumeMoneyCondition:'',
        dateCondition:'',
        integralCondition:'',
      },
      dataList: [],
      pageInfo: {
        page: 1,
        limit: 10,
      },
      loading: false,
      error: false,
      finished: false,
      finishText:'',
      isEmpty:false,
    };
  },
  created() {
    this.getList();
    this.getUnionList()
  },

  methods: {
    minConsumeMoney(list) {
      if(!list) return
      return Math.max.apply(Math, list.map(item => { return item.money }))
    },
    dropChange(){
      this.pageInfo.page = 1
      this.getList('reset')
    },
    onSearch() { 
      this.pageInfo.page = 1
      this.getList('reset')
    },
    getUnionList(){
      let _this = this
      unionPullList({}).then(res=>{
        if(res){
          if(res.data && res.data.length){
            res.data.forEach(item => {
                _this.option1.push({text:item.name,value:item.id})
            });
          }
        }
      })
    },
    beforeEnter(dom) {
      let { x = 0, y = 0, s = 1, opacity = 0 } = dom.dataset;
      dom.style.cssText = `transition: .2s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y});`;
    },
    enter(dom, done) {
      let delay = dom.dataset.delay;
      setTimeout(function () {
        dom.style.cssText = `transition: .2s;opacity: 1;transform: scale(1) translateX(0) translateY(0);`;
        //监听 transitionend 事件
        var transitionend = window.ontransitionend
          ? "transitionend"
          : "webkitTransitionEnd";
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done(); //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        });
      }, delay);
    },
    afterEnter(dom) {
      dom.style.cssText = "";
    },

    getList(type) {
      let _this = this;
      let obj = Object.assign({}, _this.pageInfo, _this.keywords);
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      activityList(obj).then((res) => {
        if (res) {
          if(res.data.totalCount==0){
            _this.isEmpty= true
          }else{
             _this.isEmpty= false
          }
          if (!res.data.list) {
            _this.finished = true;
            return;
          }
          if(type=='reset'){
             _this.dataList = []
             _this.finishText = ''
          }
          setTimeout(() => {
            _this.dataList.push(...res.data.list);
            _this.loading = false;
            if (res.data.currPage === res.data.totalPage) {
              _this.finished = true;
              _this.finishText = '亲，已经到底啦'
              return;
            }
          }, 300);
        }else{
          _this.isEmpty= true
           _this.finished = true;
          _this.dataList = []
          _this.finishText=''
        }
        _this.$toast.clear()
      }).catch(()=>{
        _this.$toast.clear()
      });
    },
    onLoad() {
      this.pageInfo.page++;
      this.getList();
    },
    handleRecDeatails(id) {
      this.$router.push({ name: "actDetail", query: { id: id } });
    },
  },
};
</script>

<style lang='less'>
.activityIndex {
  .van-dropdown-menu__title{font-size: 14px;}
  .searchWrap {
    display: flex;
    margin: 0 15px;
  }
  .searchName {
    margin-right: 10px;
    color: #000;
    line-height: 34px;
    font-size: 18px;
  }
  .searchBox {
    flex: 1;
    padding: 0;
    background: #fff;
    border-radius: 6px;
    overflow: hidden;
  }
  .van-dropdown-menu__bar {
    height: 40px;
    box-shadow: none;
    overflow-x: hidden;
  }
  .van-dropdown-menu__title {
    color: #000;
  }
}
</style>